
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Employee } from 'src/Models/Employee'
// import { ROOT_URL } from 'src/Models/Config'
import { Observable } from 'rxjs';
// import { SplashScreenStateService } from './splash-screen-state-service';

@Injectable({
  providedIn: 'root'
})
export class GenericService {

  // readonly rootURL = 'https://localhost:5001/api';
 // readonly rootURL = 'https://localhost:49155/api';
  readonly rootURL = 'https://app-mnb-api.yellowtree-8c854e2d.canadacentral.azurecontainerapps.io/api';


  constructor(private http: HttpClient ) //, private splashScreenStateService: SplashScreenStateService) 
  { }

  getItem(id: number) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURL + '/Generic/GetItemById?id=' + id;

    var ret = this.http.get<any>(url);
   // alert('service getItem done');
    return ret;
  }
  getItemDetails(id: number, mainDetParam: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURL + '/Generic/GetItemsById?siteId=' + id +'&' +'mainDet='+mainDetParam;

    var ret = this.http.get<any>(url);
   // alert('service getItemDetails done');
    return ret;
  }
  getItems(siteId: number, pMainDet: string) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");
    var url = this.rootURL + '/Generic/GetItemsById?siteId=6&mainDet=' + pMainDet;

    var ret = this.http.get<any>(url);
   // alert('service getItems done');
    return ret;
  }

  getPosts(catId: number) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");
    var url = this.rootURL + '/Generic/GetPosts?catId=' + catId;

    var ret = this.http.get<any>(url);

    return ret;
  }
  getPostById(id: number) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");
    var url = this.rootURL + '/Generic/GetPostById?id=' + id;

    var ret = this.http.get<any>(url);

    return ret;
  }
  getFilesByDirectory(id: any) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");
    var url = this.rootURL + '/Generic/GetFilesByDirectory2?folderName'+id;

    var ret = this.http.get<any>(url);

    return ret;
  }
}


